<template>
    <div class="drawerLayer" v-show="visible">
        <div class="mask" @click="close();"></div>
        <div class="bottomDrawer white_bg">
            <div class="generalPagePaddingH">
                <header class="header paddingV16">
                    <div class="flexLayout">
                        <div style="width: 16px;"></div>
                        <div class="flexItem alignCenter grey10 fWeight600">{{title}}</div>
                        <div style="width: 16px;">
                            <i class="icon closeIcon" @click="close()"></i>
                        </div>
                    </div>
                </header>
                <div class="body" style="margin-top: 10px; padding-bottom: 34px;">

                    <div class="productInfo bgFAFAFA roundBorder8 marginB24">
                        <div class="flexLayout">
                            <div style="width: 97px;">
                                <img class="fitTypeCover block" :src="product.image"
                                     width="97" height="58" style="border-radius: 6px;" v-if="product"/>
                            </div>
                            <div class="flexItem" style="line-heihgt: 20px;">
                                <div class="productTitle bold font14r">
                                    {{product ? product.title : 'loading...'}}
                                </div>
                                <div class="desc">{{product ? product.desc || '' : ''}}</div>
                            </div>
                        </div>
                    </div><!-- end .productInfo -->

                    <div class="flexLayout">
                        <div class="flexItem">
                            <button class="button shareButton" @click="share()">分享免费下载</button>
                        </div>
                        <div class="flexItem" style="margin-left: 16px;">
                            <button class="button downloadButton" @click="close(); $emit('download')">立即下载</button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import drawerPart from '../part/drawerPart';
import appHelper from "@util/appHelper";

const config = {
    name: "datumDownloadDrawer",
};

export default {
    name : config.name,
    extends : drawerPart,
    props : {
        title : {
            type : String,
            default : '标题'
        },
    },
    data() {
        return {
            product : {
                id : '',
                title : '',
                image : '',
                price : '',
            },
        }
    },
    methods : {
        share() {
            appHelper.showHint('点击右上角...菜单进行分享');
        },
        setProduct(data) {
            this.product = data;
        }

    }
}
</script>

<style lang="scss" scoped>
.header {
    .closeIcon {
        width: 14px;
        height: 14px;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACFklEQVRoge2ZQU/bMBhALWCdhPgZvfnk7305k/MkdhgwumqI/vkxpE2CaTsgtaG7xCjqbEiKnWRSntRDqzp+L0nbNDZmYmIiCHBsrT0Z2sNaewIcdxqkqh+AP8CjiHzO5PYqIvIJeAR+q2rZdtwhcAts68daVc8zegZR1Qtg3fC4NcYcvDoQeAc8NAb6iIv82s8OlzvyW+DeGHPYdgNLEakCEdmPRGDPb4EnEbnqtCERWfUdISJXEfnVvhsMRgCXadWf5TfJ5BsbDkVsnHNf0qhnlG9MkC0iu3xjouQRIfl6jpuU7s0Jk0XE5FX1Ood7c+I3Rwwm3xDYO8I5txhU3rNPBLAEqsHlPV0iRifvaRMxWnnPSxEheWA88p5YROC1ClgO7RtERL4GflX/D3lPfdr8E1EfiXHLG2OMql4HTpvkF4BZeEF+/BEh+fr57uk0vojInq+AZeQzMZ6IiPzGObfw74lFJL/m70pMPvQHPBQhItVgEV3kPaOJAG66ynsGjxCRFfC0j7xnsIgU8p7eI1LKe3qLiMiv3yLvyR4Rk095szdbRB/ynuQRfcp7kkWo6qJveQ+BtYE6ot1KkbV2BvzalSfDHekYkTWCe2vtrM34A+B786uyz9UZj6qe70R8M22WmIwxpiiKU+AO+CEiZ3lV4zjnPgI/gbuiKE47DS7L8mg+n7/P5NYaa+2sLMujoT0mJsbKX2RBsPwpegpvAAAAAElFTkSuQmCC');
    }
}
.shareButton, .downloadButton {
    display: block;
    width: 100%;
    height: 42px;
    line-height: 42px;
    border-radius: 21px;
}
.shareButton {
    background: #FFF3E0;
    color: #FFA724;

    &:before {
        display: block;
        content: '';
        position: absolute;
        margin-left: 84px;
        margin-top: -9px;
        z-index: 1;
        width: 94px;
        height: 18px;
        background-image: url('data:image/png;base64,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');
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
}
.downloadButton {
    background: linear-gradient(90deg, #FFA115 0%, #FFBF60 100%);
    color: white;
}
</style>
